import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/comments`,
      params,
    });
  },
  createItem(comment) {
    return axios({
      method: 'post',
      url: `${apiUrl}/comments`,
      data: {
        ...comment,
      },
    });
  },
  updateItem(comment) {
    return axios({
      method: 'put',
      url: `${apiUrl}/comments/${comment.id}`,
      data: {
        ...comment,
      },
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/comments/${id}`,
    });
  },
  removeItem({ id }) {
    return axios({
      method: 'delete',
      url: `${apiUrl}/comments/${id}`,
    });
  },
};
